import { Step } from '../../../types/wizard';

/**
 * This file contains type definitions and constants for use in the Sitrep
 * Section Wizard subcomponents
 */

export const DEFAULT_SECTIONS_LIST = [
  'Current Weather (ai)',
  'Forecast Weather (ai)',
  'News (ai)',
  'Social Media (ai)',
  'Power Outages (ai)',
  'Energy Reliability Index (ai)',
] as const;
export type DefaultSections = (typeof DEFAULT_SECTIONS_LIST)[number];
export const DATA_SOURCES_LIST = [
  'Files',
  'Web',
  'News',
  'Social Media',
  'Current Weather',
  'Forecast Weather',
] as const;
export type DataSourcesType = (typeof DATA_SOURCES_LIST)[number];

export const OUTPUT_FORMATTING_LIST = ['Paragraph', 'Table', 'List'] as const;
export type OutputFormatting = (typeof OUTPUT_FORMATTING_LIST)[number];

export const SECTION_TEMPLATES = 'Add Section Template';
export const SECTION = 'Section';
export const DATA = 'Data';
export const FINALIZE = 'Finalize';

export type SitrepSectionStepLabel =
  | typeof SECTION_TEMPLATES
  | typeof SECTION
  | typeof DATA
  | typeof FINALIZE;

export type SitrepSectionStep = Omit<Step, 'label' | 'pageTitle'> & {
  label: SitrepSectionStepLabel;
  pageTitle: SitrepSectionStepLabel;
};

export const SECTION_TEMPLATES_STEP: SitrepSectionStep = {
  id: 1,
  label: SECTION_TEMPLATES,
  pageTitle: SECTION_TEMPLATES,
} as const;
export const SECTION_STEP: SitrepSectionStep = {
  id: 2,
  label: SECTION,
  pageTitle: SECTION,
} as const;
export const DATA_STEP: SitrepSectionStep = {
  id: 3,
  label: DATA,
  pageTitle: DATA,
} as const;
export const FINALIZE_STEP: SitrepSectionStep = {
  id: 4,
  label: FINALIZE,
  pageTitle: FINALIZE,
} as const;

export const SITREP_SECTION_STEPS: SitrepSectionStep[] = [
  SECTION_TEMPLATES_STEP,
  SECTION_STEP,
  DATA_STEP,
  FINALIZE_STEP,
] as const;

export const DATA_SOURCES = 'Data Sources';
export const UPLOADED_FILES = 'Uploaded Files';
export type DataToggleLabels = typeof DATA_SOURCES | typeof UPLOADED_FILES;

export type DataToggleButton = {
  label: DataToggleLabels;
  value: DataToggleLabels;
};
export const DATA_TOGGLE_BUTTONS: DataToggleButton[] = [
  { label: DATA_SOURCES, value: DATA_SOURCES },
  { label: UPLOADED_FILES, value: UPLOADED_FILES },
];

export const ALLOWED_FILE_TYPES = [
  '.csv',
  '.doc',
  '.docx',
  '.md',
  '.msg',
  '.pdf',
  '.pptx',
  '.txt',
  '.url',
  '.xls',
  '.xlsx',
] as const;
export type AllowedFileTypes = (typeof ALLOWED_FILE_TYPES)[number];
